module.exports = __webpack_public_path__ + "img/logo-tsinghua.8cc2bcad.png";